import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaBolt, FaStar, FaClipboardList } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import './Hero.scss';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }
  };

  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__glow"></div>
        <div className="hero__glow-left"></div>
        <div className="hero__grid-overlay"></div>
      </div>

      <div style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
        <div className="hero__content">
          <motion.div 
            className="hero__text"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.div className="hero__badge" variants={itemVariants}>
              {/* @ts-ignore */}
              <HiSparkles className="hero__badge-icon" /> Новое решение для вашей компании
            </motion.div>

            <motion.h1 className="hero__title" variants={itemVariants}>
              Система для подачи, обработки и отслеживания <span className="text-gradient">заявок</span>
            </motion.h1>

            <motion.p className="hero__subtitle" variants={itemVariants}>
              Забудьте о хаосе в мессенджерах и потерянных задачах. 
              <br />
              <strong>beheard</strong> — наведите структурированный порядок во внутренних процессах для офисов, учебных заведений и ЖК.
            </motion.p>

            <motion.div className="hero__actions" variants={itemVariants}>
              <button 
                className="btn btn--primary"
                onClick={() => scrollToSection('contact')}
              >
                Запросить демо
              </button>
            </motion.div>
          </motion.div>

          <motion.div 
            className="hero__visual"
            initial={{ opacity: 0, x: 40, scale: 0.95 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="hero__dashboard">
              <div className="dash-header">
                <div className="dots">
                  <span></span><span></span><span></span>
                </div>
                <span className="title">Real-time Dashboard</span>
              </div>
              <div className="dash-cards">
                <motion.div 
                  className="stat-row"
                  whileHover={{ scale: 1.02 }}
                >
                  <div className="icon-box blue">
                    {/* @ts-ignore */}
                    <FaBolt />
                  </div>
                  <div className="info">
                    <span className="label">Скорость реакции</span>
                    <span className="value">В 3 раза быстрее</span>
                  </div>
                </motion.div>

                <motion.div 
                  className="stat-row"
                  whileHover={{ scale: 1.02 }}
                >
                  <div className="icon-box green">
                    {/* @ts-ignore */}
                    <FaClipboardList />
                  </div>
                  <div className="info">
                    <span className="label">Без внимания</span>
                    <span className="value">0 заявок</span>
                  </div>
                </motion.div>

                <motion.div 
                  className="stat-row"
                  whileHover={{ scale: 1.02 }}
                >
                  <div className="icon-box purple">
                    {/* @ts-ignore */}
                    <FaStar />
                  </div>
                  <div className="info">
                    <span className="label">Индекс лояльности (NPS)</span>
                    <span className="value">Повысился до 92%</span>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="hero__mission"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
        >
          <div className="mission-bar">
            <div className="benefit">
              {/* @ts-ignore */}
              <FaCheckCircle /> Полный контроль
            </div>
            <div className="separator"></div>
            <div className="benefit">
              {/* @ts-ignore */}
              <FaCheckCircle /> Экономия времени
            </div>
            <div className="separator"></div>
            <div className="benefit">
              {/* @ts-ignore */}
              <FaCheckCircle /> Прозрачная аналитика
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
